module.exports = __webpack_public_path__ + "img/logout.bc9524d9.svg";